export * from './pdf.service';
import { PdfService } from './pdf.service';
export const APIS = [PdfService];
